import React from 'react';
import "./styles.scss";

import logo from "../../../../images/Group.svg";
import { Link } from 'react-router-dom';

const platformLinks = [
    { label: 'Drawings', to: '/features/drawings' },
    { label: 'RFIs', to: '/features/rfi' },
    { label: 'Submittals', to: '/features/submittals' },
    { label: 'Daily Logs', to: '/features/daily_log' },
    { label: 'Punch Lists', to: '/features/punchlists' },
    { label: 'Locations', to: '/features/locations' },
    { label: 'Time Tracking', to: '/features/time_tracking' },
    { label: 'Asset Tracking', to: '/features/asset_tracking' },
    { label: 'Action Items', to: '/features/actions' },
    { label: 'Forms', to: '/features/forms' },
    { label: 'All features', to: '/features' },
];

export default function Footer() {
    return (
        <footer className='pl-footer'>
            <div className="footer-main">
                <div className="footer-brand">
                    <img src={logo} alt="ProjectLoop" />
                    <p>
                        The field-first construction platform. One connected project record —
                        built in Ontario, priced in CAD.
                    </p>
                    <div className="footer-contact">
                        <div>
                            <span className="footer-label">Phone</span>
                            <a href="tel:833-444-9876">833-444-9876</a>
                        </div>
                        <div>
                            <span className="footer-label">Address</span>
                            <span>361 Applewood, Concord, ON L4K 4J3</span>
                        </div>
                    </div>
                </div>
                <div className="footer-columns">
                    <div>
                        <h4>Platform</h4>
                        {platformLinks.map((link) => (
                            <Link to={link.to} key={link.label}>{link.label}</Link>
                        ))}
                    </div>
                    <div>
                        <h4>Compare</h4>
                        <Link to="/pricing">Pricing</Link>
                        <Link to="/#compare">vs legacy platforms</Link>
                        <Link to="/pricing">Free plan</Link>
                        <Link to="/signup">Start free trial</Link>
                    </div>
                    <div>
                        <h4>The Loop Family</h4>
                        <a href="https://www.safetyloop.com" target="_blank" rel="noreferrer">SafetyLoop</a>
                        <span className="footer-plain">ComplyLoop</span>
                        <Link to="/#family">Single sign-on</Link>
                    </div>
                    <div>
                        <h4>Company</h4>
                        <Link to="/about_us">About us</Link>
                        <Link to="/contact_us">Contact</Link>
                        <Link to="/login">Log in</Link>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <span>© {new Date().getFullYear()} ProjectLoop, Inc. Built in Ontario. All rights reserved.</span>
                <div>
                    <Link to="/privacy">Privacy</Link>
                    <Link to="/terms">Terms</Link>
                    <Link to="/disclaimer">Disclaimer</Link>
                </div>
            </div>
        </footer>
    )
}
